import React from "react";
import "../../assets/styles/comtwo.css";
import { useNavigate } from "react-router-dom";
import comm1 from "../../assets/images/comm1.png";
import comm2 from "../../assets/images/comm2.png";
import comm3 from "../../assets/images/comm3.png";
import comm4 from "../../assets/images/comm4.png";
import cm1 from "../../assets/images/cm1.jpg";
import cm2 from "../../assets/images/cm2.jpg";
import cm4 from "../../assets/images/cm4.jpg";
import { motion } from "framer-motion";

const ComTwo = () => {
  const navigate = useNavigate();

  const handleImageClick = (index) => {
    navigate("/products", { state: { selectedIndex: index } });
  };

  return (
    <div className="solutions-container">
      <motion.h2
        className="title"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
      >
        "INNOVATION IN MOTION, SOLUTIONS IN ACTION"
      </motion.h2>
      <motion.p
        className="descriptionnn"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
      >
        At commceed, we don’t just deliver products, we deliver forward-thinking
        <span className="hide-on-mobile">
          {" "}
          <br />{" "}
        </span>
        <span className="show-on-mobile"> &nbsp; </span>
        solutions that power your network, elevate your infrastructure, and keep
        you ahead
        <span className="hide-on-mobile">
          {" "}
          <br />{" "}
        </span>
        <span className="show-on-mobile"> &nbsp; </span>
        of the curve. With every cable, every connection, and every
        {/* <span className="hide-on-mobile">
          {" "}
          <br />{" "}
        </span> */}
        {/* <span className="show-on-mobile"> &nbsp; </span>
        provide, we turn complex challenges into seamless experiences
        transforming your ideas into reality with precision and
        <span className="hide-on-mobile">
          {" "}
          <br />{" "}
        </span>
        <span className="show-on-mobile"> &nbsp; </span>
        expertise. */}
      </motion.p>

      {/* Image Grid */}
      <div className="solutions-grid">
        <div className="solution-box" >
          <img src={cm1} alt="Cable (Copper and Fiber)"  />
           <div className="overlay">CABLE <br /> (COPPER AND FIBER)</div> 
        </div>
        <div className="solution-box" >
          <img src={cm2} alt="Save Rack and Cable Management"style={{height:"225px"}} />
           <div className="overlay">NETWORK RACKS &<br /> ENCLOSURES</div> 
        </div>
        <div className="solution-box" >
          <img src={comm3} alt="Networking and SFP" />
          <div className="overlay">
            NETWORKING
            <br />
            AND SFP
          </div>
        </div>
        <div className="solution-box" >
          <img src={cm4} alt="Manage Services" style={{height:"225px"}} />
          <div className="overlay">MANAGED <br />SERVICES</div>
        </div>
      </div>

      {/* Button */}
      <motion.div className="button-container"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, amount: 0.3 }}
      transition={{ duration: 1.5, ease: "easeInOut", delay: 1 }}>
        <motion.button
          className="all-solutions-btn"
         
          whileHover={{ scale: 1.1 }}
        >
          ALL SOLUTIONS
        </motion.button>
      </motion.div>
    </div>
  );
};

export default ComTwo;